<template>
  <div class="product">
    <div class="product-top">
      <span>
        <img src="../../assets/img/home-icon.png" alt="" class="home-icon-img">
        <router-link :to="{ name: 'home' }">首页</router-link>
      </span>&nbsp;/&nbsp;
      <span>
        产品管理
      </span>
    </div>
    <div class="product-content">
      <div class="product-content-search">
        <span class="product-search-title">名称：</span>
        <el-input v-model="productName" placeholder="请输入产品名称" class="product-name-sear"></el-input>
        <el-button icon="el-icon-search" class="product-search-btn" @click="searchHandle">搜索</el-button>
      </div>
      <el-button icon="el-icon-plus" class="add-product-btn" @click="addProductHandle">添加产品</el-button>
      <!--  -->
      <div class="product-content-box material-list" v-loading="loading">
        <div class="product-item" v-for="(item, index) in list" :key="index">
          <div class="product-item-top">
            <span class="product-item-top-left">{{ item.name }}&nbsp;&nbsp;
              <i class="el-icon-edit" style="cursor: pointer;" @click="showedit(item)"></i>
            </span>
            <span class="product-item-top-right"
              @click="urlto('/task/detail', { pid: item.product_id, name: item.name })">
              <i class="el-icon-circle-plus"></i>
              <i class="el-icon-circle-plus-outline"></i>
              <!-- 新建任务 -->
              <router-link to="" style="color: #006cff; margin-left:4px;">新建任务</router-link>
            </span>
          </div>
          <div class="product-item-content">
            <!-- 关键词 -->
            <div class="product-item-bottom-item" style="cursor: pointer;"
              @click="urlto('/material/photo', { pid: item.product_id, name: item.name })">
              <div class=" product-item-img product-item-img2">
                <img src="../../assets/img/product-item2.png" alt="">
              </div>
              <div class="product-item-right">
                <a class="product-item-right-title">相册 <i class="
                el-icon-arrow-right"></i></a>
                <span class="product-item-right-num">{{ item.album_num }}</span>
              </div>
            </div>
            <!-- 相册 -->
            <div class="product-item-bottom-item" style="cursor: pointer;"
              @click="urlto('/product/keyword', { pid: item.product_id, name: item.name })">
              <div class="product-item-img product-item-img1">
                <img src="../../assets/img/product-item1.png" alt="">
              </div>
              <div class="product-item-right">
                <router-link to="" class=" product-item-right-title">关键词<i class="
                el-icon-arrow-right"></i></router-link>
                <span class="product-item-right-num">{{ item.keywords_num }}</span>
              </div>
            </div>
            <!-- 字幕 -->
            <div class="product-item-bottom-item" style="cursor:pointer;"
              @click="urlto('/material/subtitle', { pid: item.product_id, name: item.name })">
              <div class="product-item-img product-item-img3">
                <img src="../../assets/img/product-item3.png" alt="">
              </div>
              <div class="product-item-right">
                <a class="product-item-right-title">字幕<i class="
                el-icon-arrow-right"></i></a>
                <span class="product-item-right-num">{{ item.subtitles_num }}</span>
              </div>
            </div>
            <!-- 任务数 -->
            <div class="product-item-bottom-item" style="cursor:pointer;"
              @click="urlto('/task/list', { pid: item.product_id, name: item.name })">
              <div class="product-item-img product-item-img4">
                <img src="../../assets/img/product-item4.png" alt="">
              </div>
              <div class="product-item-right">
                <router-link to="" class="product-item-right-title">任务数<i class="
                el-icon-arrow-right"></i></router-link>
                <span class="product-item-right-num">{{ item.task_num }}</span>
              </div>
            </div>
            <!-- 视频数 -->
            <div class="product-item-bottom-item" style="cursor:pointer;"
              @click="urlto('/video/list', { pid: item.product_id, name: item.name })">
              <div class="product-item-img product-item-img5">
                <img src="../../assets/img/product-item5.png" alt="">
              </div>
              <div class="product-item-right">
                <router-link to="" class="product-item-right-title">已制作/视频<i class="
                el-icon-arrow-right"></i></router-link>
                <span class="product-item-right-num">{{ item.videos }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页
        <div class="foot-page">
          <el-pagination @current-change="handleCurrentChange" :current-page="current" :page-size="pageSize"
            layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div> -->
      </div>
      <!-- 分页 -->
      <div class="foot-page item-page">
        <el-pagination @current-change="handleCurrentChange" :current-page="current" :page-size="pageSize"
          layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>

    </div>
    <!-- 添加产品弹框 -->
    <div>
      <el-dialog class="product-dialog" :visible.sync="addProductDialog" width="500px" :close-on-click-modal="false"
        top="24vh">
        <span class="product-dialog-title">
          <img src="../../assets/img/addproduct-icon.png" alt="">
          {{ form.id == 0 ? " 添加产品" : "产品编辑" }}
        </span>
        <el-form label-width="60px" :rules="productRules" :model="form">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="text">
            <el-input type="textarea" v-model="form.text" resize="none" :rows="5" placeholder="请输入描述"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="del" class="dialog-footer-btn" style="float:left" v-if="form.id > 0">删
            除</el-button>
          <el-button @click="addProductDialog = false" class="dialog-footer-btn">取 消</el-button>
          <el-button type="primary" @click="confirmProduct" class="dialog-footer-btn">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'productMainPage',
  data() {
    return {
      // 搜索名称
      productName: '',
      // 弹框
      addProductDialog: false,
      // 表单数据
      form: {
        id: 0,
        name: '',
        text: '',
      },
      // 弹框表单验证
      productRules: {
        name: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ]
      },
      // 分页
      current: 1,
      pageSize: 10,
      total: 0,
      list: [],
      loading: false,
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.current = val;
      this.query();
    },
    // 搜索
    searchHandle() {
      this.current = 1;
      this.query();
    },
    query() {
      this.loading = true;
      this.$get('/product/list', {
        page: this.current,
        size: this.pageSize,
        search: this.productName
      }).then(res => {
        this.list = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      })
    },

    // 添加产品弹框
    addProductHandle() {
      this.addProductDialog = true;
      this.form.id = 0;
      this.form.name = "";
      this.form.text = "";
    },
    //修改产品弹框
    showedit(row) {
      this.addProductDialog = true;
      this.form.id = row.product_id;
      this.form.name = row.name;
      this.form.text = row.msg;
    },
    // 弹框的确认按钮
    confirmProduct() {
      if (this.form.id == 0) {
        this.$post('/product/add', {
          product_name: this.form.name,
          msg: this.form.text
        }).then(res => {
          if (res.code == 200) {
            // this.$message.success("添加完成，继续添加相册。");
            // this.urlto('/material/photo', { pid: res.data.product_id, name: res.data.product_name })
            this.$message.success("添加完成");
            this.addProductDialog = false;
            this.query();
          } else {
            this.$message.error(res.msg);
          }
        })
      } else {
        this.$post('/product/edit', {
          product_id: this.form.id,
          msg: this.form.text,
          product_name: this.form.name
        }).then(res => {
          if (res.code == 200) {
            this.$message.success("修改完成");
            this.addProductDialog = false;
            this.query();
          } else {
            this.$message.error(res.msg);
          }
        })
      }
    },
    del() {
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post('/product/del', { product_id: this.form.id }).then(res => {
          if (res.code == 200) {
            this.$message.success("删除完成");
            this.addProductDialog = false;
            this.query();
          }
        })
      });
    },
    urlto(router, params) {
      let url = router + "?" + new URLSearchParams(params).toString();
      this.$router.push(url);
    },
    urlback() {
      this.$router.go(-1);
    },

  },
  created() {
    this.query();
  }

}

</script>
<style scoped>
.product-top {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-radius: 3px;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 16px 20px;
}

.product-top {
  color: #606266;
  font-size: 14px;
}

.product-top .home-icon-img {
  margin-right: 4px;
}

.product-top a {
  color: #606266;
}

.product-top a:hover {
  color: #006cff;
}

.product-content {
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  padding-bottom: 24px;
  overflow-y: auto;
  position: relative;
}

.product-content-search {
  box-sizing: border-box;
  padding: 16px 0;
  border-bottom: 1px dashed #e5e5e5;
}

.product-name-sear {
  width: 278px;
  height: 40px;
}

.product-search-title {
  font-size: 14px;
  color: #333;
}

.product-name-sear input {
  background-color: #fff;
  border: 1px solid #d9dde5;
  border-radius: 3px;
}

.product-search-btn {
  width: 88px;
  height: 40px;
  background-color: #006cff !important;
  border-radius: 3px;
  color: #fff !important;
  margin-left: 10px;
  border: none;
  opacity: 1;
  transition: all 0.2s linear;
}

.product-search-btn:hover {
  opacity: 0.9;
}

.add-product-btn {
  width: 130px;
  height: 40px;
  background-color: #006cff !important;
  border-radius: 3px;
  color: #fff !important;
  border: none;
  margin: 18px 0;
  opacity: 1;
  transition: all 0.2s linear;
}

.add-product-btn:hover {
  opacity: 0.9;
}

.product-item {
  box-sizing: border-box;
  border: 1px solid #e6e8ee;
  padding: 18px 20px;
  margin-bottom: 14px;
  border-radius: 5px;
}

.product-item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-item-top-left {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  height: 20px;

}

.product-item-top-right {
  font-size: 14px;
  color: #006cff;
  cursor: pointer;
}

.product-item-top-right .el-icon-circle-plus {
  display: none;
}

.product-item-top-right:hover .el-icon-circle-plus {
  display: inline-block;
}

.product-item-top-right:hover .el-icon-circle-plus-outline {
  display: none;
}

.product-item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.product-item-bottom-item {
  display: flex;
}

.product-item-bottom-item:hover .product-item-right-title {
  color: #006cff;
}

.product-item-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-item-img1 {
  background-color: #fff5f1;
}

.product-item-img2 {
  background-color: #edfbf6;
}

.product-item-img3 {
  background-color: #ebf4ff;
}

.product-item-img4 {
  background-color: #fffaec;
}

.product-item-img5 {
  background-color: #fff5f1;
}

.product-item-right {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  justify-content: space-between;
}

.product-item-right-title {
  font-size: 14px;
  color: #7e868f;
}

.product-item-right-num {
  font-size: 20px;
  color: #000;
}

.page-content {
  display: flex;
  align-content: center;
  justify-content: center;
  margin-top: 20px;
  bottom: 30px;
  left: 14%;
}

.page-content .el-pagination {
  color: #606266;
  font-weight: 400;
}

.page-content .el-pagination>>>button {
  border: 1px solid #d9d9d9 !important;
  border-radius: 3px;
  padding: 0;
  min-width: 28px !important;
}

.page-content .el-pagination .btn-next,
.el-pagination .btn-prev {
  background: center center no-repeat #FFF;
  background-size: 16px;
  cursor: pointer;
  margin: 0;
  color: #606266;
}

.page-content .el-pagination .el-select .el-input {
  width: 90px;
  margin: 0 5px;
}

.page-content .el-pagination>>>.el-pagination__jump {
  margin-left: 10px;
  font-weight: 400;
  color: #606266;
}

.product-dialog>>>.el-dialog {
  border-radius: 5px;
}

.product-dialog>>>.el-dialog__header {
  height: 46px;
  padding: 0;
  background-image: url(../../assets/img/addproduct-bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.product-dialog-title {
  position: absolute;
  display: flex;
  align-items: center;
  top: 13px;
  left: 20px;
  font-size: 13px;
  color: #fff;
  font-weight: bold;
}

.product-dialog-title img {
  margin-right: 10px;
}

.product-dialog>>>.el-dialog__headerbtn {
  position: absolute;
  top: 15px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

.product-dialog>>>.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.product-dialog>>>.el-form .el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #696969;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

.product-dialog>>>.el-dialog__body {
  padding: 19px 20px 10px 30px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  border-bottom: 1px solid #ebf0f6;
}

.product-dialog .el-form .el-form-item {
  margin-bottom: 20px;
}

.product-dialog .dialog-footer-btn {
  width: 74px;
  height: 36px;
  padding: 0;
  border-radius: 3px;
}

.product-dialog .el-dialog__footer {
  padding: 16px 20px 20px;
  text-align: right;
  box-sizing: border-box;
}

.product-dialog>>>.el-input__inner {
  font-size: 14px;
  color: #999;
  font-family: Microsoft YaHei UI !important;
}

.product-dialog>>>.el-textarea__inner {
  font-size: 14px;
  color: #999;
  font-family: Microsoft YaHei UI !important;

}

.product-content-box {
  height: calc(100vh - 340px);
}

@media screen and (max-width:1250px) {
  .product-content {
    min-height: 620px;
  }
}
</style>